const ProfessionsData = [
  {
    name: 'Appliance Professional',
    id: 'profession-appliance'
  },
  {
    name: 'Appraiser',
    id: 'profession-appraiser'
  },
  {
    name: 'Architect',
    id: 'profession-architect'
  },
  {
    name: 'Attorney - Bankruptcy',
    id: 'profession-attorneybankruptcy'
  },
  {
    name: 'Attorney - Elder Law',
    id: 'profession-attorneyelderlaw'
  },
  {
    name: 'Attorney - Estate & Probate',
    id: 'profession-estateattorney'
  },
  {
    name: 'Attorney - Family Law',
    id: 'profession-attorneyfamilylaw'
  },
  {
    name: 'Attorney - Real Estate',
    id: 'profession-attorneyrealestate'
  },
  {
    name: 'Bookkeeper',
    id: 'profession-bookkeeper'
  },
  {
    name: 'Carpet Cleaning Professional',
    id: 'profession-carpetcleaningprofessional'
  },
  {
    name: 'Commercial Broker',
    id: 'profession-commercialbroker'
  },
  {
    name: 'Commercial Lender',
    id: 'profession-commerciallender'
  },
  {
    name: 'Countertop Professional',
    id: 'profession-countertop'
  },
  {
    name: 'Divorce Financial Analyst',
    id: 'profession-divorcefinancialanalyst'
  },
  {
    name: 'Divorce Mediator',
    id: 'profession-divorcemediator'
  },
  {
    name: 'Drywall Professional',
    id: 'profession-drywall'
  },
  {
    name: 'Electrical Contractor',
    id: 'profession-electricalprofessional'
  },
  {
    name: 'Environmental Services Professional',
    id: 'profession-environmentalservices'
  },
  {
    name: 'Estate Planning Coordinator',
    id: 'profession-estateplanningcoordinator'
  },
  {
    name: 'Estate Sale Coordinator',
    id: 'profession-estatesalecoordinator'
  },
  {
    name: 'Exterior Cleaning Professional',
    id: 'profession-exteriorcleaning'
  },
  {
    name: 'Fence & Deck Contractor',
    id: 'profession-fencedeckcontractor'
  },
  {
    name: 'Financial Advisor',
    id: 'profession-financialadvisor'
  },
  {
    name: 'Flooring Contractor',
    id: 'profession-flooringprofessional'
  },
  {
    name: 'Foundations Professional',
    id: 'profession-foundations'
  },
  {
    name: 'Garage Door Professional',
    id: 'profession-garagedoor'
  },
  {
    name: 'Garage Flooring Professional',
    id: 'profession-garageflooring'
  },
  {
    name: 'General Contractor',
    id: 'profession-generalcontractor'
  },
  {
    name: 'Handyman',
    id: 'profession-generalhandyman'
  },
  {
    name: 'Home Decor & Interior Designer',
    id: 'profession-homedecorinteriordesigner'
  },
  {
    name: 'Home Security Specialist',
    id: 'profession-homesecurityspecialist'
  },
  {
    name: 'Home Storage Designer',
    id: 'profession-homestoragedesigner'
  },
  {
    name: 'Home Warranty Specialist',
    id: 'profession-homewarrantyspecialist'
  },
  {
    name: 'HVAC Professional',
    id: 'profession-hvacprofessional'
  },
  {
    name: 'Insurance Agent - Business',
    id: 'profession-insurancebusiness'
  },
  {
    name: 'Insurance Agent - Life',
    id: 'profession-insurancelife'
  },
  {
    name: 'Insurance Agent - Property & Casualty',
    id: 'profession-insurancepropertycasualty'
  },
  {
    name: 'Interior Cleaning Professional',
    id: 'profession-interiorcleaning'
  },
  {
    name: 'Junk Removal Specialist',
    id: 'profession-junkremoval'
  },
  {
    name: 'Land Surveyor',
    id: 'profession-landsurveyor'
  },
  {
    name: 'Landscaping Professional',
    id: 'profession-landscapingprofessional'
  },
  {
    name: 'Lighting Specialist',
    id: 'profession-lightingspecialist'
  },
  {
    name: 'Moving Specialist',
    id: 'profession-movingprofessional'
  },
  {
    name: 'National Discount Center',
    id: 'profession-federation-nationaldiscountcenter'
  },
  {
    name: 'New Home Builder',
    id: 'profession-newhomebuilder'
  },
  {
    name: 'Painting Contractor',
    id: 'profession-paintingprofessional'
  },
  {
    name: 'Pest Control Professional',
    id: 'profession-pestcontrolprofessional'
  },
  {
    name: 'Plumbing Contractor',
    id: 'profession-plumbingprofessional'
  },
  {
    name: 'Pool Service Provider',
    id: 'profession-poolserviceprofessional'
  },
  {
    name: 'Banker - Private',
    id: 'profession-privatebanker'
  },
  {
    name: 'Banker - Retail',
    id: 'profession-retailbanker'
  },
  {
    name: 'Professional Recruiter',
    id: 'profession-professionalrecruiter'
  },
  {
    name: 'Property Inspector',
    id: 'profession-homeinspector'
  },
  {
    name: 'Property Manager',
    id: 'profession-propertymanager'
  },
  {
    name: 'Property Manager - Short Term Rentals',
    id: 'profession-propertymanagerstr'
  },
  {
    name: 'Property Service Professional',
    id: 'profession-propertyservice'
  },
  {
    name: 'Real Estate Agent',
    id: 'profession-realtor'
  },
  {
    name: 'Remodeling Contractor',
    id: 'profession-remodelingcontractor'
  },
  {
    name: 'Residential Lender',
    id: 'profession-loanofficer'
  },
  {
    name: 'Restoration Specialist',
    id: 'profession-restorationcompany'
  },
  {
    name: 'Reverse Mortgage Specialist',
    id: 'profession-reversemortgageprofessional'
  },
  {
    name: 'Roofing Contractor',
    id: 'profession-roofingprofessional'
  },
  {
    name: 'Senior Advisor',
    id: 'profession-senioradvisor'
  },
  {
    name: 'Septic Professional',
    id: 'profession-septic'
  },
  {
    name: 'Solar Panel Technician',
    id: 'profession-solarpanelprofessional'
  },
  {
    name: 'Sprinkler Specialist',
    id: 'profession-sprinklers'
  },
  {
    name: 'Tax Professional',
    id: 'profession-taxprofessional'
  },
  {
    name: 'Tech Support Professional',
    id: 'profession-techsupport'
  },
  {
    name: 'Tree Service Professional',
    id: 'profession-treetrimmingprofessional'
  },
  {
    name: 'Well Professional',
    id: 'profession-well'
  },
  {
    name: 'Window & Siding Contractor',
    id: 'profession-windowsidingcontractor'
  },
  {
    name: 'Window Treatment Specialist',
    id: 'profession-windowtreatmentspecialist'
  },
  {
    name: 'Broker Owner',
    id: 'profession-proinsightbrokerowner'
  },
  {
    name: 'Business Consultant',
    id: 'profession-proinsightbusinessconsultant'
  },
  {
    name: 'Certified Coach',
    id: 'profession-coach'
  },
  {
    name: 'Exit Strategist',
    id: 'profession-proinsightexitstrategist'
  },
  {
    name: 'Network Advisor',
    id: 'profession-proinsightbuilder'
  },
  {
    name: 'Team Leader',
    id: 'profession-proinsightteamleader'
  },
  {
    name: 'Title Rep',
    id: 'profession-proinsighttitlerep'
  }
]

export { ProfessionsData }
